var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orders-list-table" },
    [
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: { data: _vm.dataList },
          on: { "selection-change": _vm.onSelectionChange },
        },
        [
          _vm._l(
            _vm.config,
            function ({ type, prop, label, width, slot, align, fixed }) {
              return [
                type
                  ? _c("el-table-column", {
                      key: prop,
                      attrs: {
                        label: label,
                        type: type,
                        "min-width": width,
                        align: align,
                      },
                    })
                  : slot
                  ? _c(
                      "el-table-column",
                      {
                        key: prop,
                        attrs: {
                          prop: prop,
                          label: label,
                          "min-width": width,
                          fixed: fixed,
                          align: align,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  slot === "goods" &&
                                  _vm.typeStr === "logisticsOrder"
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "itemN",
                                            style: {
                                              zIndex: 100 - scope.$index,
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                },
                                              },
                                              [
                                                scope.row.orderNo
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "margin-left": "40px",
                                                          cursor: "pointer",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.copyInfo(
                                                              scope.row.orderNo
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " 订单编号：" +
                                                            _vm._s(
                                                              scope.row.orderNo
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  { staticClass: "hint_pr" },
                                                  [
                                                    _vm._v(
                                                      " 创建时间：" +
                                                        _vm._s(
                                                          scope.row.createdTime
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "hint_pr" },
                                                  [
                                                    _vm._v(
                                                      "支付时间：" +
                                                        _vm._s(
                                                          scope.row.payTime
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "hint_pr",
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.copyInfo(
                                                          scope.row.outTradeNo
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 支付单号：" +
                                                        _vm._s(
                                                          scope.row.outTradeNo
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "hint_pr" },
                                                  [
                                                    _vm._v(
                                                      " 订单类型：" +
                                                        _vm._s(
                                                          scope.row
                                                            .orderTypeLabel
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "hint_pr-operation",
                                                staticStyle: {
                                                  "margin-right": "60px",
                                                },
                                              },
                                              [
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticStyle: {
                                                        color: "#2d46ee",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toOtherPages(
                                                            "logisticsOrderDetail",
                                                            scope.row,
                                                            "Details"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("查看/编辑")]
                                                  ),
                                                ],
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                        scope.row.orderDetailList
                                          ? _c(
                                              "div",
                                              _vm._l(
                                                scope.row.orderDetailList,
                                                function (item, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass: "mesSty",
                                                    },
                                                    [
                                                      _c("el-image", {
                                                        staticStyle: {
                                                          "margin-top": "4px",
                                                        },
                                                        attrs: {
                                                          src: item.goodsImg,
                                                          fit: "cover",
                                                        },
                                                      }),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "mesFont",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                width: "100%",
                                                                display:
                                                                  "-webkit-box",
                                                                "-webkit-box-orient":
                                                                  "vertical",
                                                                "-webkit-line-clamp":
                                                                  "2",
                                                                "text-overflow":
                                                                  "ellipsis",
                                                                overflow:
                                                                  "hidden",
                                                                "margin-left":
                                                                  "8px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    item.goodsName
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                width: "100%",
                                                                display:
                                                                  "-webkit-box",
                                                                "-webkit-box-orient":
                                                                  "vertical",
                                                                "-webkit-line-clamp":
                                                                  "1",
                                                                "text-overflow":
                                                                  "ellipsis",
                                                                overflow:
                                                                  "hidden",
                                                                "margin-left":
                                                                  "8px",
                                                                "font-size":
                                                                  "13px",
                                                                "font-family":
                                                                  "Microsoft YaHei",
                                                                "font-weight":
                                                                  "400",
                                                                "line-height":
                                                                  "17px",
                                                                color:
                                                                  "#606066",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " 规格：" +
                                                                  _vm._s(
                                                                    item.goodsSkuName
                                                                  ) +
                                                                  " * " +
                                                                  _vm._s(
                                                                    item.goodsQuantity
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                      ]
                                    : _vm._e(),
                                  slot === "no" && _vm.typeStr === "afterOrder"
                                    ? [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "itemN",
                                            style: {
                                              zIndex: 100 - scope.$index,
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                },
                                              },
                                              [
                                                scope.row.orderNo
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          "margin-left": "40px",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " 订单编号：" +
                                                            _vm._s(
                                                              scope.row.orderNo
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.routeObj.name ===
                                                  "ordersList" ||
                                                _vm.routeObj.name ===
                                                  "operatorsOrderList"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "hint_pr",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " 客户：" +
                                                            _vm._s(
                                                              scope.row.userName
                                                            ) +
                                                            "（" +
                                                            _vm._s(
                                                              scope.row
                                                                .userPhone
                                                            ) +
                                                            "） "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.routeObj.name ===
                                                "operatorsOrderList"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "hint_pr",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " 订单类型：" +
                                                            _vm._s(
                                                              scope.row
                                                                .orderTypeLabel
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.routeObj.name ===
                                                "operatorsOrderList"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "hint_pr",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " 业绩归属人：" +
                                                            _vm._s(
                                                              scope.row
                                                                .achievementUserName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                scope.row.applierName
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "hint_pr tooltip",
                                                        attrs: {
                                                          "aria-label":
                                                            "点击复制",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.copyInfo(
                                                              scope.row,
                                                              "service"
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " 跟进客服：" +
                                                            _vm._s(
                                                              scope.row
                                                                .applierName
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                scope.row.createdTime &&
                                                _vm.isShowTime.createdTime
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "hint_pr",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.typeStr ===
                                                                "operation"
                                                                ? "提交时间"
                                                                : "下单时间"
                                                            ) +
                                                            "：" +
                                                            _vm._s(
                                                              scope.row
                                                                .createdTime
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                scope.row.submitDate &&
                                                _vm.isShowTime.submitDate
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "hint_pr",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " 提交审核时间：" +
                                                            _vm._s(
                                                              scope.row
                                                                .status == 99
                                                                ? "-"
                                                                : scope.row
                                                                    .submitDate
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "hint_pr-operation",
                                                staticStyle: {
                                                  "margin-right": "50px",
                                                },
                                              },
                                              [
                                                [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticStyle: {
                                                        color: "#2d46ee",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.toOtherPages(
                                                            "afterOrderDetail",
                                                            scope.row,
                                                            "Details"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("查看")]
                                                  ),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticStyle: {
                                                        color: "#2d46ee",
                                                        "margin-left": "10px",
                                                      },
                                                      on: { click: _vm.apply },
                                                    },
                                                    [_vm._v("审核")]
                                                  ),
                                                ],
                                              ],
                                              2
                                            ),
                                          ]
                                        ),
                                        scope.row.details
                                          ? _c("div", [_vm._v("111111111")])
                                          : _vm._e(),
                                      ]
                                    : _vm._e(),
                                  slot === "user"
                                    ? [
                                        _c("p", [
                                          _vm._v(_vm._s(scope.row.userName)),
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            "(ID:" +
                                              _vm._s(scope.row.userId) +
                                              ")"
                                          ),
                                        ]),
                                        _c("p", [
                                          _vm._v(_vm._s(scope.row.userPhone)),
                                        ]),
                                      ]
                                    : _vm._e(),
                                  slot === "postName"
                                    ? [
                                        _c("p", [
                                          _vm._v(_vm._s(scope.row.postName)),
                                        ]),
                                        _c("p", [
                                          _vm._v(_vm._s(scope.row.postPhone)),
                                        ]),
                                      ]
                                    : _vm._e(),
                                  slot === "userCommission"
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              Number(
                                                scope.row.userCommission
                                              ).toFixed(2)
                                            )
                                          ),
                                        ]),
                                      ]
                                    : _vm._e(),
                                  slot === "vipCommission"
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              Number(
                                                scope.row.vipCommission
                                              ).toFixed(2)
                                            )
                                          ),
                                        ]),
                                      ]
                                    : _vm._e(),
                                  slot === "order"
                                    ? [
                                        _c(
                                          "p",
                                          {
                                            attrs: {
                                              title: scope.row.statusLabel,
                                            },
                                          },
                                          [
                                            _c("i", {
                                              class: [
                                                {
                                                  "danger-bg":
                                                    scope.row.status == 1,
                                                },
                                                {
                                                  "info-bg":
                                                    scope.row.status == 7,
                                                },
                                                {
                                                  "warning-bg":
                                                    scope.row.status == 2 ||
                                                    scope.row.status == 3 ||
                                                    scope.row.status == 4 ||
                                                    scope.row.status == 5,
                                                },
                                                "round",
                                                {
                                                  "success-bg":
                                                    scope.row.status === 6,
                                                },
                                              ],
                                            }),
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row.statusLabel) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  slot === "amount"
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              Number(
                                                scope.row.receivableAmount
                                              ).toFixed(2)
                                            )
                                          ),
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            "(含快递:" +
                                              _vm._s(
                                                Number(
                                                  scope.row.freightAmount
                                                ).toFixed(2)
                                              ) +
                                              ")"
                                          ),
                                        ]),
                                      ]
                                    : _vm._e(),
                                  slot === "goodsAmount"
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              Number(
                                                scope.row.goodsAmount
                                              ).toFixed(2)
                                            )
                                          ),
                                        ]),
                                      ]
                                    : _vm._e(),
                                  slot === "discountAmount"
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              Number(
                                                scope.row.discountAmount
                                              ).toFixed(2) || 0.0
                                            )
                                          ),
                                        ]),
                                      ]
                                    : _vm._e(),
                                  slot === "operation"
                                    ? [
                                        _c("p", [
                                          _vm._v(
                                            "操作人：" +
                                              _vm._s(scope.row.closedPersonName)
                                          ),
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            "时间：" +
                                              _vm._s(scope.row.closedTime)
                                          ),
                                        ]),
                                      ]
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c("template", { slot: "header" }, [
                          slot === "userCommission" || slot === "vipCommission"
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "30px",
                                    display: "flex",
                                    "justify-content": "center",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { "line-height": "30px" } },
                                    [_vm._v(_vm._s(label))]
                                  ),
                                  slot === "vipCommission"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "5px" },
                                        },
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content:
                                                  "该笔订单中服务商最终获得的佣金；（平台佣金+平台利润-用户佣金+扣除保证金）",
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "18px",
                                                  height: "18px",
                                                  "margin-left": "4px",
                                                },
                                                attrs: {
                                                  src: require("../../../assets/icon/icon_qipao.png"),
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  slot === "userCommission"
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: { "margin-top": "5px" },
                                        },
                                        [
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content:
                                                  "该笔订单中用户获得的佣金；（商品金额*特定的商品佣金）",
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticStyle: {
                                                  width: "18px",
                                                  height: "18px",
                                                  "margin-left": "4px",
                                                },
                                                attrs: {
                                                  src: require("../../../assets/icon/icon_qipao.png"),
                                                },
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              )
                            : _c("div", [_vm._v(_vm._s(label))]),
                        ]),
                      ],
                      2
                    )
                  : _c("el-table-column", {
                      key: prop,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        align: align,
                      },
                    }),
              ]
            }
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "售后申请",
            visible: _vm.isApply,
            width: "518px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isApply = $event
            },
          },
        },
        [
          [
            _c("div", { staticClass: "info" }, [_vm._v("是否审核通过？")]),
            _c(
              "div",
              { staticStyle: { "margin-top": "18px" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.radio,
                      callback: function ($$v) {
                        _vm.radio = $$v
                      },
                      expression: "radio",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 3 } }, [_vm._v("通过")]),
                    _c("el-radio", { attrs: { label: 6 } }, [_vm._v("驳回")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.radio == 3
              ? _c("div", { staticClass: "pass" }, [
                  _vm._v(" 确认后，金额"),
                  _c("span", { staticClass: "price" }, [_vm._v("￥1000.00")]),
                  _vm._v("将退回买家账户 "),
                ])
              : _vm._e(),
            _vm.radio == 6
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "24px",
                      width: "90%",
                      "margin-bottom": "24px",
                    },
                  },
                  [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-right": "8px", width: "10%" },
                        },
                        [_vm._v("备注")]
                      ),
                      _c(
                        "div",
                        { staticStyle: { width: "90%" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入备注",
                              maxlength: "200",
                              "show-word-limit": "",
                              rows: "5",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isApply = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-s",
                    on: {
                      click: function ($event) {
                        _vm.isApply = false
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }